const enLocale = {
	'heading.footerText': 'By continuing you are agreeing to our',
	'heading.termsOfService': 'Terms of service',
	'commonStrings.contactinfo': 'Contact Info',
	'commonStrings.forgotPassword': 'Forgot password?',
	'commonStrings.signIn': 'Sign in',
	'commonStrings.username': 'Username',
	'commonStrings.currentUser': 'Current user',
	'commonStrings.password': 'Password',
	'commonStrings.currentPassword': 'New password',
	'commonStrings.confirmPassword': 'Confirm password',
	'commonStrings.loginTitle': 'Welcome',
	'commonStrings.mobileLoginTitle': 'Welcome to Control Panel',
	'commonStrings.mobileWelcomeMessage':
		'Manage the full restaurant experience all on one platform',
	'commonStrings.loginManageTitle': 'Lavu Admin Login',
	'commonStrings.recoverPassword': 'Recover your password.',
	'commonStrings.refreshPage': 'Refresh',
	'loginErrors.networkErrorMsg': 'Please check your internet connection. ',
	'loginErrors.empty.username': 'Please enter your username',
	'loginErrors.empty.password': 'Please enter your password',
	'loginErrors.empty.passwordRedo': 'Please enter your confirmation password',
	'hubqlErrors.SessionTimeOut': 'Session expired due to inactivity or your network changed. Please click on Refresh button below',
	'hubqlErrors.InternalError':
		'An internal error has occurred! Please try again later.',
	'hubqlErrors.UsernameOrPasswordIncorrect':
		'Incorrect username and/or password',
	'hubqlErrors.AccessLevelRequired': 'Sorry, you have insufficient access',
	'hubqlErrors.Inactive': 'Sorry this account has been deactivated',
	'hubqlErrors.UnknownError':
		'An unknown error has occurred! Please try again later',
	'hubqlErrors.UserNotFound': `Sorry, we couldn't find the user you are looking for.`,
	'hubqlErrors.MaximumResetTokens':
		'You have exceeded the total number of attempts allowed to reset your password for the next 24 hours.',
	'hubqlErrors.InvalidEmail': `This user doesn't have a valid email`,
	'hubqlErrors.TokenAlreadyUsed':
		'The current token has been already used. Please complete the forgot password form again to receive a new one',
	'passwordResetForm.returnLogin': 'Return to Login',
	'passwordResetCommon.resetPasswordTitle': 'Password reset',
	'passwordResetCommon.successSubTitle': 'Check your spam inbox just in case.',
	'passwordResetCommon.defaultSubTitle':
		'We’ll email you instructions to reset your password.',
	'passwordResetCommon.submitBtnMsg': 'Reset password',
	'passwordResetCommon.linkToLoginMsg': 'Go back to Login',
	'passwordResetEmail.successSentEmail':
		'Success! We sent an email with instructions to reset your password.',
	'passwordResetEmail.errorUsername':
		'Sorry, that username is invalid. If you feel this is an error please contact ',
	'passwordResetEmail.customerCare': 'Customer Care',
	'landingResetForm.successResetPassword': 'Your new password has been set up.',
	'landingResetForm.newPasswordSuccessSubTitle':
		'Your password has been successfully changed.',
	'landingResetForm.passwordDoesntMatch': "The passwords don't match.",
	'landingResetForm.errorResetPassword':
		"Sorry, we couldn't update your user. If this persist please contact ",
	'landingResetForm.newPasswordError':
		'Password must have at least 8 characters',
	'landingResetForm.confirmPasswordError': "Password doesn't match",
};

export default enLocale;
